const FacilityManagementTypes = {
    reit: 'REIT',
    sophisticated: 'Sophisticated',
    nonDesignated: 'Non-designated',
};

export default FacilityManagementTypes;
